import Component from '../abstracts/Component';

export default class SizesComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-sizes',
      main: '.js-variant-list',
      target: '.js-size-trigger'
    };
  }

  get CLASSES() {
    return {
      selected: 'selected',
      show: 'show'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.container = $(this.SELECTORS.container);
  }

  bindEvents() {

    let ctx = this;

    // click on a size in pdp or in wishlist item
    $('body').on('click.selectSize', ctx.SELECTORS.target, function() {

      let $selectedSize = $(this);
      let isDisabled = $selectedSize.data('disabled') === true;
      let notifyMeIsEnabled = $('body').data('isNotifyMeEnabled');
      let inWishlistLayer = $selectedSize.closest('.product-item').length === 1;

      $(ctx.SELECTORS.target).removeClass(ctx.CLASSES.selected);
      $selectedSize.addClass(ctx.CLASSES.selected);


      if (!isDisabled) {
        if (inWishlistLayer) {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {
            button: $selectedSize,
            inWishlistLayer: true
          });
        } else {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizechanged,  {button: $selectedSize});
        }

      } else {
        if ($selectedSize.data('inMiniWishlist') ) {
          //go to wishlist if click a disabled size from miniwishlist
          window.location.href = $selectedSize.data('linkWishlist');
        } else {
          //in pdp, set size in addtowishlist for unavailable product
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizechanged, {button: $selectedSize});
          if (!notifyMeIsEnabled) {
            $(".js-unavailable-size").addClass("show");
          } else {
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, {button: $selectedSize});
            if (ctx.$matchMedia('sm', null)){
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.disableProductButton, {button: $selectedSize});
            }
          }
        }
      }
    })
    this.$on('click.closeSize', ({event}) => {
      let $this = $(event.currentTarget);
      let $layer = $this.closest(ctx.SELECTORS.container);
      this.$emit(this.$customEvents.SIZES_EVENTS.sizesclose, { layer: $layer } )
    }, 'body', `${this.SELECTORS.container} .js-close`);

    this.$on(this.$customEvents.BACKDROP_EVENTS.hide, ({event, payload}) => {
      this.$emit(this.$customEvents.SIZES_EVENTS.sizesclose, { layer: ctx.SELECTORS.container, fromBd: true } )
    });



    this.$on(this.$customEvents.SIZES_EVENTS.sizesclose, ({event, payload}) => {
      $(payload.layer).removeClass(ctx.CLASSES.show);
      if (this.$matchMedia('sm', null) && !payload.fromBd) this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    });

    this.$on(this.$customEvents.SIZES_EVENTS.sizesopen, ({event, payload}) => {
      let $cartBar = payload.parent;
      let inQuickBuy = $cartBar.closest('.modal-quick-buy').length == 1;
      let $el = $cartBar.find(ctx.SELECTORS.container);
      $el.addClass(ctx.CLASSES.show);
      if (ctx.$matchMedia('sm', null)) ctx.$emit(ctx.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark', inModal: inQuickBuy});
    });


  }

  render() {
    this.bindEvents();
  }
}
